// 活動記録のエンティティ
export class Reports {
  // 授業ID DB型(*autokeyFk)
  public class_id?: number;
  // 先生ユーザーID DB型(*fk)
  public tea_user_id?: string;
  // 生徒ユーザーID DB型(*fk)
  public stu_user_id?: string;
  // 日付 DB型(DATE)
  public report_date?: Date;
  // 教科 DB型(*varchar256)
  public subject?: string;
  // 本日のゴール DB型(*varchar1024)
  public lesson_goal?: string;
  // ゴール達成のポイント DB型(MEDIUMTEXT)
  public lesson_point?: string;
  // ゴール達成率 DB型(INT)
  public goal_rate?: number;
  // 生徒の様子 DB型(MEDIUMTEXT)
  public student_state?: string;
  // 宿題 DB型(MEDIUMTEXT)
  public homework?: string;
  // 保護者へひとこと DB型(MEDIUMTEXT)
  public to_parent?: string;
  // 編集ロック取得日時 DB型(DATETIME)
  public locking_dt?: Date;
  // 編集者 DB型(*fk)
  public locking_user_id?: string;
  // 送信済み DB型(*flg)
  public is_send?: boolean;
  // 記入者 DB型(*varchar256)
  public auther_name?: string;
  // 評価 DB型(INT)
  public evaluation?: number;
  static fromDB(record: { [column: string]: any; [column: number]: any }): Reports {
    const entity = new Reports();
    entity.class_id = record['class_id'];
    entity.tea_user_id = record['tea_user_id'];
    entity.stu_user_id = record['stu_user_id'];
    entity.report_date = record['report_date'];
    entity.subject = record['subject'];
    entity.lesson_goal = record['lesson_goal'];
    entity.lesson_point = record['lesson_point'];
    entity.goal_rate = record['goal_rate'];
    entity.student_state = record['student_state'];
    entity.homework = record['homework'];
    entity.to_parent = record['to_parent'];
    entity.locking_dt = record['locking_dt'];
    entity.locking_user_id = record['locking_user_id'];
    entity.is_send = record['is_send'];
    entity.auther_name = record['auther_name'];
    entity.evaluation = record['evaluation'];
    return entity;
  }
  static getTypeFitEntity(value: any): Reports {
    const entity = new Reports();
    entity.class_id = value.class_id;
    entity.tea_user_id = value.tea_user_id;
    entity.stu_user_id = value.stu_user_id;
    entity.report_date = value.report_date;
    entity.subject = value.subject;
    entity.lesson_goal = value.lesson_goal;
    entity.lesson_point = value.lesson_point;
    entity.goal_rate = value.goal_rate;
    entity.student_state = value.student_state;
    entity.homework = value.homework;
    entity.to_parent = value.to_parent;
    entity.locking_dt = value.locking_dt;
    entity.locking_user_id = value.locking_user_id;
    entity.is_send = value.is_send;
    entity.auther_name = value.auther_name;
    entity.evaluation = value.evaluation;
    return entity;
  }
}
